import SettingsRoutes from "./settings"
import ProductionRoutes from "./production"
import IntakeRoutes from "./intake"
import FinanceRoutes from "./finance"
import QualityControlRoutes from "./quality-control"
import SalesRoutes from "./sales"


export default [
    ...SettingsRoutes,
    ...ProductionRoutes,
    ...IntakeRoutes,
    ...FinanceRoutes,
    ...QualityControlRoutes,
    ...SalesRoutes,
]